import React from 'react';
import styled from 'styled-components';
import { ListingDTO } from '../../../api/model';
import ListingHelper from '../../../lib/listing-helper';
import { isMobileVersion } from '../../../lib/soar-helper';

interface ActiveMapLegendProps {
    listing: ListingDTO;
}

const ActiveMapLegend = (props: ActiveMapLegendProps) => {
    if (!props.listing.files || props.listing.files.length === 0) {
        return <React.Fragment />;
    }

    return (
        <React.Fragment>
            {props.listing.files.map((attachedFile) => {
                if (attachedFile.type !== 'LEGEND') {
                    return <React.Fragment />;
                } else {
                    return (
                        <React.Fragment>
                            {isMobileVersion ? <Divider /> : null}
                            <LegendTitle>Legend</LegendTitle>
                            <LegendContainer>
                                <Legend
                                    key={attachedFile.id}
                                    src={ListingHelper.getUrlForListingFile(attachedFile.listingId, attachedFile.id)}
                                />
                            </LegendContainer>
                        </React.Fragment>
                    );
                }
            })}
        </React.Fragment>
    );
};

export default ActiveMapLegend;

const LegendContainer = styled.div`
    @media only screen and (max-width: 600px) {
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

const Legend = styled.img`
    max-width: 100%;

    @media only screen and (max-width: 600px) {
        padding: 8px;
    }
`;

const LegendTitle = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 1rem;
    margin: 34px 0px 6px 0px;
    display: block;

    @media only screen and (max-width: 600px) {
        font-size: 1rem;
        margin: 6px 0px 0px 8px;
    }
`;

const Divider = styled.div`
    height: 1px;
    width: 100vw;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;
